import FieldTooltip from './FieldTooltip.jsx';

function DocumentUploader({
  label,
  required,
  icon = 'badge',
  file,
  onFileChange,
  tooltipTitle,
  tooltipBullets = [],
  guideImage,
  guideImageAlt,
  footerHint,
  inputId,
}) {
  const guideList = (
    <ul className="tm-reg-tooltip-list">
      {tooltipBullets.map((t) => (
        <li key={t}>{t}</li>
      ))}
    </ul>
  );

  return (
    <div className="tm-reg-doc-field">
      <div className="tm-reg-doc-label-row">
        <span className="material-symbols-outlined tm-reg-doc-label-icon">{icon}</span>
        <span className="tm-reg-doc-label-text">
          {label}
          {required && <span className="tm-reg-required"> *</span>}
        </span>
        <FieldTooltip
          label="Ver guía de subida"
          title={tooltipTitle}
          imageSrc={guideImage}
          imageAlt={guideImageAlt}
        >
          {guideList}
        </FieldTooltip>
      </div>
      <label className="tm-reg-doc-drop" htmlFor={inputId}>
        <span className="material-symbols-outlined tm-reg-doc-cloud">cloud_upload</span>
        <span className="tm-reg-doc-drop-text">Subir imagen</span>
        {file && <span className="tm-reg-doc-file-name">{file.name}</span>}
        <input
          id={inputId}
          type="file"
          accept="image/*"
          className="tm-registro-file-input"
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) onFileChange(f);
          }}
          required={required}
        />
      </label>
      {footerHint && <p className="tm-reg-doc-footer-hint">{footerHint}</p>}
    </div>
  );
}

export default DocumentUploader;
